import styled from 'styled-components'

import { Card } from '../../../components/Base/Base'
import { DocumentList } from '../../../components/Documents/DocumentList'
import { InlineSpinner } from '../../../components/Spinner'
import { useDocuments } from '../../../hooks/query/useDocuments'
import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  FolderName,
} from '../../../models/document'
import { User } from '../../../models/user'

interface ProfileDocumentsProps {
  user: User
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function ProfileDocuments({ user, onDocumentOpen, renderDocumentAction }: ProfileDocumentsProps) {
  const { documents, isLoading } = useDocuments(user.id, FolderName.ROOT)

  if (!documents || isLoading) {
    return <InlineSpinner mt={5} mb={5} />
  }

  return (
    <StyledCard hasSubtleShadow smallerPadding align="left">
      <DocumentList
        recordId={user.id}
        folder={FolderName.ROOT}
        displayFolders={[FolderName.DRIVER_INFO, FolderName.TRUCK]}
        onDocumentOpen={onDocumentOpen}
        renderDocumentAction={renderDocumentAction}
      />
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  padding-bottom: 0;
`
